module.exports = __webpack_public_path__ + "static/media/fan-song.7a2fd18e.jpg";